import { gql } from "@apollo/client";

export const LIST_MY_BOOKINGS = gql`
  query listMyBookings {
    listMyBookings {
      items {
        id
        eventId
        customerName
        customerEmail
        customerPhone
        horseIds
        startTime
        endTime
        status
        notes
        depositAmount
        depositPaidAt
        scanAmount
        balanceDue
        createdAt
      }
    }
  }
`;

export const GET_BOOKING_POLICY = gql`
  query getBookingPolicy {
    getBookingPolicy {
      cancelWindowHours
      noShowRequiresFullPayment
    }
  }
`;
